import type { AccountSessionPersistence } from "./AccountSession.ts";

const RETURN_PATH_KEY = "auth-return-to";

function browserNavigationStorage(): Pick<Storage, "getItem" | "setItem" | "removeItem"> | null {
	return typeof window === "undefined" ? null : window.sessionStorage;
}

export const browserAccountSessionStorage: AccountSessionPersistence = {
	writeReturnPath: (path) => browserNavigationStorage()?.setItem(RETURN_PATH_KEY, path),
	takeReturnPath: () => {
		const storage = browserNavigationStorage();
		const path = storage?.getItem(RETURN_PATH_KEY) ?? null;
		storage?.removeItem(RETURN_PATH_KEY);
		return path;
	},
	clearReturnPath: () => browserNavigationStorage()?.removeItem(RETURN_PATH_KEY),
};
